import type { Ref } from 'vue';
import { cssSafeId } from './utils';

export function useDragTransform(
  /* parent element to define css-vars on */
  tableRef: Ref<HTMLElement | undefined>,
  /* css-var prefix (i.e. row/column) */
  prefix: string
) {
  const keys = new Set<string>();

  function setOffset(id: string, value: string) {
    const el = tableRef.value;
    if (!el) return;
    const key = `--${prefix}-offset-${cssSafeId(id)}`;
    el.style.setProperty(key, value);
    keys.add(key);
  }

  function clearOffsets() {
    const el = tableRef.value;
    if (!el) {
      keys.clear();
      return;
    }
    for (const key of keys) {
      el.style.removeProperty(key);
    }
    keys.clear();
  }

  return { setOffset, clearOffsets };
}
